import { isMobileViewport, watchMobileViewport } from './mobileViewport'

// A full mobile popover needs an explicit close target even when its reference is covered.
export default function installMobilePopoverSupport(Vue) {
  Vue.mixin({
    mounted() {
      if (this.$options.name !== 'ElPopover') return
      const routeName = this.$route && this.$route.name || ''
      if (/performance|qiancMaterial/i.test(routeName)) return
      let button = null
      const refresh = () => {
        if (!isMobileViewport()) {
          if (button && button.parentNode) button.parentNode.removeChild(button)
          button = null
          return
        }
        const popper = this.$refs.popper
        if (!popper || button) return
        button = document.createElement('button')
        button.type = 'button'
        button.className = 'jl-mobile-popover-close'
        button.setAttribute('aria-label', '关闭说明浮层')
        button.textContent = '关闭'
        button.addEventListener('click', event => { event.stopPropagation(); this.doClose() })
        popper.insertBefore(button, popper.firstChild)
      }
      const stop = watchMobileViewport(refresh)
      this._jlCleanupPopover = () => {
        stop()
        if (button && button.parentNode) button.parentNode.removeChild(button)
      }
      refresh()
    },
    beforeDestroy() { if (this._jlCleanupPopover) this._jlCleanupPopover() }
  })
}



// WEBPACK FOOTER //
// ./src/utils/mobilePopoverSupport.js